import { useField } from 'formik';

import {
  DemographicFormData,
  getAudienceGroups,
  getEmptyAudienceTarget,
} from '../../../../util/demographics';
import { AudienceGroup } from '../../../../types/domainModels';

import FormSearchSelectInputV2 from 'components/common/forms/FormSearchSelectInputV2';
import Icon from 'components/common/Icon';
import IconBackground from 'components/common/icons/IconBackground';
import { Targets } from './Targets';

export const DemographicTarget = ({
  audienceGroups,
  index,
  onRemoveCategory,
}: {
  audienceGroups: AudienceGroup[];
  index: number;
  onRemoveCategory?: () => void;
}): JSX.Element => {
  const audienceGroupFieldName = `audienceProfile.audienceTargets.${index}.audienceGroupId`;
  const surveyAudienceTypesFieldName = `audienceProfile.audienceTargets.${index}.surveyAudienceTypes`;

  const [{ value: selectedAudienceGroupId }] = useField<
    DemographicFormData['audienceProfile']['audienceTargets'][number]['audienceGroupId']
  >(audienceGroupFieldName);
  const [, , surveyAudienceTypesHelpers] = useField<
    DemographicFormData['audienceProfile']['audienceTargets'][number]['surveyAudienceTypes']
  >(surveyAudienceTypesFieldName);
  const [{ value: allSelectedAudienceGroups }] = useField<
    DemographicFormData['audienceProfile']['audienceTargets']
  >('audienceProfile.audienceTargets');

  return (
    <div className="flex flex-wrap">
      <div className="w-80 mr-2">
        <FormSearchSelectInputV2
          borderColor="#D9D9D9"
          name={audienceGroupFieldName}
          onChange={(value) => {
            surveyAudienceTypesHelpers.setValue([
              getEmptyAudienceTarget(value?.value),
            ]);
          }}
          options={getAudienceGroups({
            groups: audienceGroups,
            allSelectedAudienceGroups,
            thisSelectedAudienceGroupId: selectedAudienceGroupId,
          })}
          placeholder="Audience Target List"
        />
      </div>
      {onRemoveCategory && (
        <div className="mt-2">
          <IconBackground
            onClick={onRemoveCategory}
            size="small"
            title="Delete Target"
          >
            <div className="w-3 h-3">
              <Icon id="trash" />
            </div>
          </IconBackground>
        </div>
      )}
      {selectedAudienceGroupId && (
        <Targets
          index={index}
          selectedAudienceGroupId={selectedAudienceGroupId}
        />
      )}
    </div>
  );
};
